import getContext from './getContext';
function gaHandler() {
  const context = getContext();
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (process.env.NODE_ENV === 'development') {
    console.info('[GA]:', ...args);
  } else if (context[context.GoogleAnalyticsObject]) {
    context[context.GoogleAnalyticsObject](...args);
  } else {
    console.error('GA is not loaded on the page');
  }
}
export default gaHandler;